import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Catalogs|Credential|Related Credentials|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCredentialRelatedCredentials';
export type SPCredentialRelatedCredentialsLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelFilterByStatus`;

export const spCredentialRelatedCredentialsLocs: LocDefs<SPCredentialRelatedCredentialsLocNames> = {
	SPCredentialRelatedCredentialsTitlePage: {
		defaultValue: 'Credential Related Credentials',
		description: 'Page Title.',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Credential/CatalogsCredential.RelatedCerts.Title.PageTitle',
		...sharedProperties,
	},
	SPCredentialRelatedCredentialsTitleTab: {
		defaultValue: 'Credential Related Credentials',
		description: 'Tab Title.',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Credential/CatalogsCredential.RelatedCerts.Title.TabTitle',
		...sharedProperties,
	},
	SPCredentialRelatedCredentialsLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Credential/Catalogs.Credentials.ColumnHeading.RelatedCertsName',
		...sharedProperties,
	},
	SPCredentialRelatedCredentialsLabelStatus: {
		defaultValue: 'Status',
		description: 'Column heading for: Status.',
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'Credential/Catalogs.Credentials.ColumnHeading.RelatedCertsStatus',
		...sharedProperties,
	},
	SPCredentialRelatedCredentialsLabelFilterByStatus: {
		defaultValue: 'Filter by Status',
		description: 'Label for: Filter by Status.',
		displayPath: `${pathStart}Filter by Status`,
		displayType: 'Label',
		legacyName: 'Credential/Catalogs.Credentials.ColumnHeading.RelatedCertsFilterStatus',
		...sharedProperties,
	},
};

export type SPCredentialRelatedCredentialsLocType = LocMap<SPCredentialRelatedCredentialsLocNames>;
